<!--
 * @Author: guoyu
 * @Date: 2020-04-28 12:39:24
 * @LastEditors: your name
 * @LastEditTime: 2020-06-16 13:34:59
 * @Description: 综合评分B端用户解释弹窗
 -->
<template>
  <el-dialog
    :visible.sync="popupShow"
    class="explain-container"
    custom-class="dialog-clear-style explain-container-wrap"
    :show-close="false"
    top="50vh"
    width="375px"
    append-to-body
    @close="$emit('close', false)"
  >
    <header class="explain-title">
      <fps-icon class="explain-close" type="close" @click.native="$emit('close', false)" />
      綜合評分
    </header>
    <div class="score-explain">
      <div class="container">
        <scoreCard :score="score" ref="cardRef"></scoreCard>
        <div class="explain">
          <div class="title">
            <img src="~@/assets/images/light.png" />
            綜合評分越高，分配的曝光量越高
          </div>
          <div class="list">
            <h3>什麼是綜合評分？</h3>
            <p>綜合評分是根據陪玩師最近30天的綜合表現計算出來的分數，評分並非累積制，而是根據陪玩師30天綜合表現持續變動。</p>
            <h3>綜合評分的構成</h3>
            <p>綜合評分根據陪玩師的體驗品質，積極響應，魅力表現，在線活躍等幾個方面進行分數計算。</p>
            <h3>提高綜合評分小貼士</h3>
            <p>
              提供優質的教學品質很重要！無論是常來光顧的用戶，還是詳細好評數，都是多多益善喔~
            </p>
            <ul>
              <li>
                積極拓展新客源
                <dl>
                  <dd>在“發現好頭家”和“最近來訪”列表中，找到頭像有優惠券標籤的，即將在平台首次下單的新用戶，主動積極與他們聊聊，努力為新用戶提供優質的體驗</dd>
                </dl>
              </li>
              <li>
                體驗品質
                <dl>
                  <dd>提高您的教學質量</dd>
                  <dd>收穫二次下單用戶和詳細好評</dd>
                  <dd>獲得訂單與禮物</dd>
                </dl>
              </li>
              <li>
                積極響應
                <dl>
                  <dd>在1分鐘內即時回覆用戶給您發起的會話</dd>
                  <dd>主動聯繫查看過你的用戶</dd>
                  <dd>參與極速約單搶單並認真填寫搶單內容</dd>
                </dl>
              </li>
              <li>
                魅力表現
                <dl>
                  <dd>用心打造您的個人主頁，技能介紹</dd>
                  <dd>讓更多用戶造訪您的主頁，與您打招呼</dd>
                </dl>
              </li>
              <li>
                在線活躍
                <dl>
                  <dd>近30天的活躍情況</dd>
                </dl>
              </li>
            </ul>
            <h3>如果您有不良行為，會被扣除綜合評分</h3>
            <dl>
              <dt>不良行為包括：</dt>
              <dd>被玩家評價差評</dd>
              <dd>遭檢舉涉及違規</dd>
            </dl>
          </div>
          <p>綜合評分每日8點統一進行各維度結算，可能會有延遲，請耐心等待。</p>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import scoreCard from './score-card.vue';
export default {
  components: { scoreCard },
  model: {
    event: 'close',
    prop: 'show',
  },
  data() {
    return {
      isPC: true,
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    score: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    // 移动端从底部弹出
    popupPosition() {
      if(this.isPC) {
        return ''
      }
      return 'bottom'
    },
    popupShow: {
      get() {
        return this.show;
      },
      set(newVal) {
        this.$emit('close', newVal);
      },
    },
  },
  watch: {
    popupShow(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.cardRef.animate();
        });
      }
    },
  },
  methods: {
    judgePlatform() {
      if(window.innerWidth>=600) {
        this.isPC = true
      } else {
        this.isPC = false
      }
    },
  },
  created() {
    this.$nextTick(() => {
      this.$refs.cardRef.animate();
    });
    this.judgePlatform()
  }
};
</script>
<style lang="scss" scoped>
  .explain-container {
    & /deep/ .explain-container-wrap {
      .el-dialog__body {
        background: #fff;
        border-radius: 8px;
        width: 375px;
        border-radius: 8px;
        text-align: left;
        transform: translateY(-50%);
        max-height: 500px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
      }
    }
  }
  .explain-title {
    position: relative;
    width: 100%;
    padding: 18px 20px;
    border-bottom: solid 1px #E3E3E3;
    line-height: 1;
    font-weight: 600;
    font-size: 16px;
    color: #171717;
    background: #fff;
  }
  .explain-close {
    position: absolute;
    right: 23px;
    top: 17px;
    font-size: 18px;
    color: $color-gray-3;
    cursor: pointer;
  }

  .score-explain {
    position: relative;
    z-index: 0;
    width: 100%;
    flex: 1;
    overflow-y: auto;
    @include hideScrollBar(0, 0);
    .container {
      padding: 0 20px;
      position: relative;
    }
    .score {
      width: 100%;
      height: 70px;
      line-height: 70px;
      color: #333;
      font-size: 14px;
      span {
        font-size: 18px;
        font-weight: 500;
        margin-left: 15px;
      }
    }
    .explain {
      margin-top: 30px;
      .title {
        @include flex;
        color: #333;
        font-size: 16px;
        font-weight: 500;
        padding-right: 10px;
        img {
          width: 30px;
          height: 30px;
          margin-right: 10px;
        }
      }
      p {
        color: #999;
        font-size: 14px;
        line-height: 20px;
        text-align: left;
      }
      .list {
        border-top: 1PX solid #F4F4F4;
        border-bottom: 1PX solid #F4F4F4;
        margin-top: 25px;
        padding-bottom: 25px;
        overflow: hidden;
        font-size: 14px;
        text-align: left;
        line-height: 20px;
        h3 {
          margin: 25px 0 12px;
          color: #333;
          font-size: 16px;
          font-weight: 500;
        }
        ul {
          li {
            list-style: decimal inside;
            color: #333;
            font-weight: 500;
            margin-top: 25px;
          }
        }
        dl {
          margin-top: 12px;
          dt {
            color: #333;
          }
          dd {
            color: #999;
            font-weight: normal;
            margin-top: 12px;
            &::before {
              content: '• ';
              font-size: 16px;
              font-weight: 500;
            }
          }
        }
      }
      > p {
        margin: 25px 0 30px;
      }
    }
  }
</style>
